import { useFormik } from "formik";
import React from "react";
import globalMU from "../../../../globalMU";
const estiloEditarParcelaContrato = require("./editar-parcela-contrato.module.scss").default
const estilosFormulario = require('app/estilos/formulario.module.scss').default

export type EditarParcelaContratoFormulario = {

  NumeroDocumento?: string;
  NumeroBanco?: string;
  NumeroAgencia?: string;
  NumeroConta?: string;
  Vencimento?: string;
  Valor?: number;
};

export type EditarParcelaContratoProps = {
  somenteLeitura:boolean
  editarParcelaContratoFormulario: EditarParcelaContratoFormulario;
  onAplicar: (editarParcelaContratoFormulario: EditarParcelaContratoFormulario) => void;
};

export const EditarParcelaContrato = (props: EditarParcelaContratoProps) => {
  const formik = useFormik({
    initialValues: { ...props.editarParcelaContratoFormulario },
    onSubmit: (values, {}) => {},
    enableReinitialize: true,
  });

  const numeroDocumentoInput = <>
    <label>Nº Documento</label>
    <input
      name="NumeroDocumento"
      id="EditarParcelaContrato_NumeroDocumento"
      value={(formik.values?.NumeroDocumento) ?? ""}
      onChange={formik.handleChange}
      disabled={props.somenteLeitura}
      maxLength={20}
    />
  </>

  const bancoInput = <>
    <label>Banco</label>
    <input
      name="NumeroBanco"
      value={(formik.values?.NumeroBanco) ?? ""}
      onChange={formik.handleChange}
      disabled={props.somenteLeitura}
      maxLength={3}
    />
  </>

  const agenciaInput = <>
    <label>Agência</label>
    <input
      name="NumeroAgencia"
      value={(formik.values?.NumeroAgencia) ?? ""}
      onChange={formik.handleChange}
      disabled={props.somenteLeitura}
      maxLength={4}
    />
  </>

  const contaInput = <>
    <label>Conta</label>
    <input
      name="NumeroConta"
      value={(formik.values?.NumeroConta) ?? ""}
      onChange={formik.handleChange}
      disabled={props.somenteLeitura}
      maxLength={10}
    />
  </>

  const dataVencimentoInput = <>
    <label>Data Vencimento</label>
    <input
      name="Vencimento"
      value={(globalMU.formatDate(formik.values?.Vencimento)) ?? ""}
      disabled
    />
  </>

  const valorInput = <>
    <label>Valor</label>
    <input
      name="Valor"
      value={(globalMU.formatarValorNumerico(formik.values?.Valor, 2, true)) ?? ""}
      disabled
    />
  </>

  return (
    <>
      <div className={estiloEditarParcelaContrato.separador} />
      <div
        className={estilosFormulario.formulario}
      >
        
        {numeroDocumentoInput}

        {bancoInput}
        
        {agenciaInput}

        {contaInput}

        {dataVencimentoInput}

        {valorInput}
        {!props.somenteLeitura && 
        <div className={estiloEditarParcelaContrato.botaoEditarParcelaContrato}>
          <button onClick={() => props.onAplicar(formik.values)}
           id="EditarParcelaContrato_BotaoAplicar">
            Aplicar
          </button>
        </div>
        }
      </div>
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};
